import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ArrowDown, MinusCircle, RefreshCw, PauseCircle, Repeat } from 'lucide-react';
export function Method4R() {
  const steps = [{
    id: 'R1',
    title: 'Reducir irritantes',
    subtitle: '(7 días)',
    desc: 'Bajamos lo que típicamente te infla: gaseosas, alcohol, fritos, azúcar, ultraprocesados, comer a las corridas.',
    icon: <MinusCircle className="w-8 h-8 text-white" data-id="element-99" />,
    color: 'bg-rose'
  }, {
    id: 'R2',
    title: 'Reemplazar',
    subtitle: '(sin drama)',
    desc: 'Te doy opciones simples para que no te quedes “sin qué comer”.',
    icon: <RefreshCw className="w-8 h-8 text-white" data-id="element-100" />,
    color: 'bg-sage'
  }, {
    id: 'R3',
    title: 'Regular estrés',
    subtitle: '(2 minutos)',
    desc: 'Porque si tu sistema está en alerta, la digestión no acompaña.',
    icon: <PauseCircle className="w-8 h-8 text-white" data-id="element-101" />,
    color: 'bg-terracotta'
  }, {
    id: 'R4',
    title: 'Repetir sistema',
    subtitle: '',
    desc: 'Menú + lista + prep + tracker. Menos decisiones. Menos ansiedad.',
    icon: <Repeat className="w-8 h-8 text-white" data-id="element-102" />,
    color: 'bg-brown-light'
  }];
  return <section className="py-24 px-4 bg-sage text-white" data-id="element-103">
      <div className="max-w-6xl mx-auto" data-id="element-104">
        <FadeIn className="text-center mb-16" data-id="element-105">
          <h2 className="text-3xl md:text-4xl font-serif mb-4 text-white" data-id="element-106">
            La solución: Método 4R Livianas
          </h2>
          <p className="text-sage-50 text-lg max-w-2xl mx-auto" data-id="element-107">
            Este plan está armado para que funcione en una semana real.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-108">
          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.1} className="h-full" data-id="element-109">
              <div className="bg-white/10 backdrop-blur-sm border border-white/20 p-8 rounded-2xl h-full hover:bg-white/15 transition-colors duration-300" data-id="element-110">
                <div className="flex items-start gap-6" data-id="element-111">
                  <div className={`${step.color} p-4 rounded-xl shadow-lg flex-shrink-0`} data-id="element-112">
                    {step.icon}
                  </div>
                  <div data-id="element-113">
                    <div className="flex flex-wrap items-baseline gap-2 mb-3" data-id="element-114">
                      <h3 className="text-2xl font-serif font-medium" data-id="element-115">
                        {step.id} — {step.title}
                      </h3>
                      {step.subtitle && <span className="text-sage-50 font-medium" data-id="element-116">
                          {step.subtitle}
                        </span>}
                    </div>
                    <p className="text-sage-50 text-lg leading-relaxed" data-id="element-117">
                      {step.desc}
                    </p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}